

const unpublish = require('./entry-unpublish');
const processError = require('./error-process');

module.exports = (entry) => {
  const needsArchiving = !entry.isArchived();

  if (!needsArchiving) {
    return Promise.resolve(entry);
  }

  return unpublish(entry).then(() => {
    return entry.archive().catch(
      processError
    );
  });
};
